import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { KeyContext } from "../context/SearchKeyProvider";
import { Link, Navigate } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_URL;

const SearchPage = () => {
  const { key } = useContext(KeyContext);
  const token = localStorage.getItem("token");

  const fetchProducts = async () => {
    const res = await axios.get(`${baseUrl}productlist?keyword=${key}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data.products;
  };

  const { data: products = [], isLoading } = useQuery({
    queryKey: ["search-products", key],
    queryFn: fetchProducts,
    enabled: !!key,
  });

  if (!key) return <Navigate to="/shop" />;

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border" style={{ color: "#0f4372" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4" style={{ minHeight: "60vh" }}>
      <div className="row g-3">
        {products.map((product) => (
          <div
            key={product._id}
            className="d-flex align-items-center p-3 shadow-sm bg-white rounded"
            style={{ gap: "1rem" }}
          >
            <img
              src={product.productImage}
              alt={product.product_name}
              style={{
                width: "90px",
                height: "90px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
            <div className="flex-grow-1">
              <h6 className="mb-1 fw-semibold text-dark">{product.product_name}</h6>
              <p className="mb-1 text-muted">
                £{parseFloat(product.discount_price).toFixed(2)}{" "}
                <span className="ms-3 text-success">Stock: {product.stock || "Variable Stock"}</span>
              </p>
            </div>
            <div>
              <Link to={`/product_details/${product._id}`}
                className="btn btn-sm"
                style={{ backgroundColor: "#0f4372", color: "white" }}
              >
                Details
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchPage;
